module.exports = __webpack_public_path__ + "img/upload-s-1.60a31ece.svg";